import { JsonFilterPipe } from '../../filters/json-filter.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemBookingStatusSwitchComponent } from '../../components/item-booking-status-switch/item-booking-status-switch.component';
import { CardProfileComponent } from '../../components/card-profile/card-profile.component';
import { Component, OnInit, OnDestroy, inject, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import * as menu from '../../config/menu.json';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import DialogServices from '../../services/dialog.service';
import Config from '../../utils/config.service';
import Session from '../../utils/session.service';
import ProfilePictureService from '../../services/profile-picture.service';
import ProfileServices from '../../services/profile.service';
import InsuranceService from '../../services/insurance.service';
import RestService from '../../services/core-rest.service';
import UserRestServices from '../../services/user-rest.service';
import UrlUtil from '../../utils/url-util.service';
import CallService from '../../services/call.service';
import PushNotificationService from '../../services/push-notification.service';
import ServiceRestServices from '../../services/service-rest.service';
import CategoryService from '../../services/category.service';
import FetchingService from '../../services/fetching.service';
import BookingsService from '../../services/bookings.service';
import NotificationService from '../../services/notification.service';
import InstantBookingService from '../../services/instant-booking.service';
import BusinessService from '../../services/business.service';
import UserService from '../../services/user.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import AngularStateHelperService from '../../services/angular-state-helper.service';
import AppLanguageService from '../../services/app-language.service';
import moment from 'moment';
import { Router, NavigationEnd, RouterLink } from '@angular/router';
import { MatSelectModule } from '@angular/material/select';
import { ModalCallIncomingComponent } from '../modal-call-incoming/modal-call-incoming.component';
import { ModalTagSelectionComponent } from '../modal-tag-selection/modal-tag-selection.component';
import { ModalBrowserInfoComponent } from '../modal-browser-info/modal-browser-info.component';
import { ModalPharmacyConsentsComponent } from '../modal-pharmacy-consents/modal-pharmacy-consents.component';
import { SiffiLanguagePickerComponent } from '../siffi-language-picker/siffi-language-picker.component';
import { Subscription, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import MyTrainingComponent from "../../views/my-training/my-training.component";
import ToolkitService from '../../services/toolkit.service';

@Component({
	standalone: true,
	selector: 'header',
	templateUrl: './header.component.html',
	imports: [
		CommonModule, MatSelectModule, JsonFilterPipe, TranslatePipe, 
		ItemBookingStatusSwitchComponent, CardProfileComponent, 
		FormsModule, RouterLink, SiffiLanguagePickerComponent, MyTrainingComponent
	]
})
export class HeaderComponent implements OnInit, OnDestroy {
	private readonly toolkitMenuVisible = true;
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private dialogServices: DialogServices = inject(DialogServices);
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private profilePictureService: ProfilePictureService = inject(ProfilePictureService);
	private profileServices: ProfileServices = inject(ProfileServices);
	private insuranceService: InsuranceService = inject(InsuranceService);
	private restService: RestService = inject(RestService);
	private userRestServices: UserRestServices = inject(UserRestServices);
	private urlUtil: UrlUtil = inject(UrlUtil);
	private callService: CallService = inject(CallService);
	private pushNotificationService: PushNotificationService = inject(PushNotificationService);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private categoryService: CategoryService = inject(CategoryService);
	private fetchingService: FetchingService = inject(FetchingService);
	private bookingsService: BookingsService = inject(BookingsService);
	private notificationService: NotificationService = inject(NotificationService);
	private instantBookingService: InstantBookingService = inject(InstantBookingService);
	private businessService: BusinessService = inject(BusinessService);
	private userService: UserService = inject(UserService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private angularStateHelperService: AngularStateHelperService = inject(AngularStateHelperService);
	private appLanguageService: AppLanguageService = inject(AppLanguageService);
	private router: Router = inject(Router);
	private toolkitService: ToolkitService = inject(ToolkitService);

	searchSubject: Subject<string> = new Subject<string>();
	vm: any = undefined;
	navigationSubscription: Subscription = undefined;
	walletSubscription: Subscription = undefined;
	watchers: Array<any> = [];
	broadcastSubscriptions: Array<Subscription> = [];

	constructor(private ngZone: NgZone) {
		this.vm = this;
		this.vm.search = {};
		
		this.searchSubject.pipe(
			debounceTime(500)
		).subscribe(searchTerm => {
			this.triggerSearch(false);
		});
	}
	
	ngOnInit() {
		this.initialize();
		
		this.callService.init();
		this.pushNotificationService.init();
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onRootEvent(this.config.getBroadcastConfig().Chat.INIT,
				(event, chats) => {
					this.vm.chats = chats;
				})
		);
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onRootEvent(this.config.getBroadcastConfig().Chat.NEW,
				(event, chat) => {
					this.vm.chats[chat.id] = chat;
				})
		);
		
		this.vm.getUnreadChatsCount = () => {
			return Object.keys(this.angularFilterHelperService.unreadChats(this.vm.chats)).length;
		};
		
		this.vm.searchLanguages = this.config.getServiceLanguages();
		
		this.vm.editProfile = this.editProfile;
		this.vm.toggleDrawer = this.toggleDrawer;
		this.vm.getProfileImg = this.profilePictureService.getProfilePictureUrl;
		this.vm.logout = this.logout;
		this.vm.toggleServiceProviderRole = this.toggleServiceProviderRole;
		this.vm.toggleAdminAssistantStatus = this.toggleAdminAssistantStatus;
		this.vm.setLocale = this.setLocale;
		this.vm.shouldBeVisible = this.shouldBeVisible;
		this.vm.triggerSearch = this.triggerSearch;
		this.vm.isTagFilterVisible = this.isTagFilterVisible;
		this.vm.clearSelectedTag = this.clearSelectedTag;
		this.vm.clearAllSelectedTags = this.clearAllSelectedTags;
		this.vm.openTagSelectionDialog = this.openTagSelectionDialog;
		this.vm.requestCategorySelection = this.requestCategorySelection;
		this.vm.getCategoryTranslation = this.getCategoryTranslation;
		this.vm.getLanguagesText = this.getLanguagesText;
		this.vm.reload = this.reload;
		this.vm.reloadToPrevisit = this.reloadToPrevisit;
		this.vm.getLocaleOption = this.getLocaleOption;
		this.vm.toggleLangMenu = this.toggleLangMenu;
		this.vm.goBack = this.goBack;
		this.vm.goToPharmacy = this.goToPharmacy;
		this.vm.isVisibleForUser = this.isVisibleForUser;
		this.vm.isCategorySelectionRequested = true;
		this.vm.isCategoryPsychology = false;
		this.vm.availableTags = [];
		this.vm.selectedTags = [];
		this.vm.hasIiziBusinessWallet = false;
		this.vm.checkMentalHealthService = this.checkMentalHealthService;
		this.vm.startTimeInHours = 0;
		this.vm.endTimeInHours = 23;
		this.vm.handleTabClick = this.handleTabClick;
		this.vm.getTherapiesText = this.getTherapiesText;
		this.vm.getSessionLimitInfo = this.getSessionLimitInfo;
		this.vm.getGlobalProperty = this.getGlobalProperty;
		this.vm.isShowTabs = this.isShowTabs;
		this.vm.typeOfAppointments = ['FACE_TO_FACE_SESSION_ONLY', 'VIDEO_SESSION_ONLY'];
		this.vm.hasAssignedLearnerPrograms = false;
	}
	
	ngOnDestroy() {
		if (this.navigationSubscription) {
			this.navigationSubscription.unsubscribe();
		}
		if (this.walletSubscription) {
			this.walletSubscription.unsubscribe();
		}
		for (var i = 0; i < this.watchers.length; i++) {
			this.angularHelperService.cancelInterval(this.watchers[i]);
		}
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	ngAfterViewInit() {
		setTimeout(() => {
			this.updateSearchBarAndBackground();
		}, 200);
	}
	
	onSearchChange(searchTerm: string) {
		this.searchSubject.next(searchTerm);
	}
	
	getGlobalProperty(name) {
		return this.angularStateHelperService.getGlobalProperty(name);
	}
	
	initialize() {
		setTimeout(console.log.bind(console, "\n%cStop!", "color:red;font-size:50px;font-weight:bold;text-shadow: 1px 1px 0px black, 1px -1px 0px black, -1px 1px 0px black, -1px -1px 0px black;"));
		setTimeout(console.log.bind(console, "This is a browser feature intended for developers. If someone told you to copy and paste something here, it is a scam and will give them access to your %caccount. ",
			"color:red;", "Don't copy/paste anything here if you are not a developer and don't have an understanding of what you are doing."));
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(
				this, this.config.getBroadcastConfig().Session.LOGIN, (event, data) => {
					this.vm.isHomePage = this.angularRoutingHelperService.getCurrentPath() === '/' 
						|| this.angularRoutingHelperService.getCurrentPath() === '';

					this.vm.selectedTab = 0;
					this.vm.availableTherapies = [];
					
					var currentSession = this.session.getSession();
					var origin: any = (currentSession?.user?.origin) ? currentSession.user.origin : 'minudoc.ee';

					this.updateUserData();
					this.checkTabsVisibility();
					this.checkProfileHeaderVisibility();
					if (origin == 'siffi.com') {
						this.checkMentalHealthServiceAvailable();
					}

					this.vm.isSearchable = this.vm.isHomePage && !this.vm.user.businessUser;
					if (this.vm.user.businessUser && this.vm.user.businessUserType) {
						this.vm.noHeroBanner = true;
					}
					var location: any = window.location.href;
					if (location.includes('eelvisiit')) {
						this.vm.previsitLocation = true;
					}
					if (this.vm.isSearchable) this.initializeSearch();

					this.vm.locales = this.appLanguageService.getLanguagesByOrigin(origin);

					this.constructMenuLinks();
					if(!this.vm.user.businessUser && !this.vm.user.businessUserType) {
						this.loadAssignedLearnerProgramsVisibility();
						this.loadAssignedToolkitVisibility();
					}
					if (this.vm.user.businessUserType !== 'SERVICE_OWNER' && this.vm.user.businessUserType !== 'BUSINESS_CLIENT') {
						this.angularHelperService.createTimer(() => {
							// low priority, delay check for improved first load performance
							this.checkAutoplay();
						}, 5000);
					}

					if (this.vm.user.signupCompleted && this.vm.user.businessUserType === 'SERVICE_PROVIDER') {
						// only request notification permission immediately for service providers
						// in general it is considered bad practice to do it without a related action 
						// (incoming chat post, new booking, instant request)
						// but it makes sense for service providers.
						this.notificationService.requestPermission();
					}

					var isProfileEditChainRequested: any = false;
					if (currentSession
						&& (!this.vm.user.signupCompleted || this.isProfileUpdateRequired())
						&& !this.vm.initialized
						&& this.vm.user.businessUserType !== 'SERVICE_OWNER'
						&& this.vm.user.businessUserType !== 'BUSINESS_CLIENT') {
						isProfileEditChainRequested = true;
						this.editProfile(null, this, this.onEditProfileDialogClosed, this.onEditProfileDialogClosed);
					}

					// delay shop prescription banner and insurance attention check, lower priority
					this.angularHelperService.createTimer(() => {
						if (!isProfileEditChainRequested
							&& this.vm.user.businessUserType !== 'SERVICE_OWNER'
							&& this.vm.user.businessUserType !== 'BUSINESS_CLIENT') {
							this.checkInsuranceAttentionRequired();
						}

						if (origin == 'minudoc.ee') {
							this.vm.isPharmacyPurchasingSupported = this.config.getPharmacyConfig().PURCHASING_SUPPORTED;
							if (this.vm.isHomePage && !this.vm.user.businessUserType) {
								var opts: any = {
									status: 'COMPLETED',
									orderBy: 'id',
									ascending: false,
									prescriptionsOnly: true,
									start: 0,
									pageSize: 10
								};
								this.serviceRestServices.getBookings(opts, (bookings) => {
									this.vm.prescriptionRenewals = bookings.filter((booking) => {
										return booking.bookingInstantRequest
											&& booking.bookingInstantRequest.prescriptionRequest
											&& booking.bookingInstantRequest.prescriptionRequest.prescriptionNumber
											&& moment(booking.scheduledStart).diff(moment(), 'hours', true) >= -48
											|| booking.bookingPrescription && booking.bookingPrescription.prescriptionNumber;
									});
								});
							}
						}
					}, 300);

					//this.angularStateHelperService.scopeWF(this, this.userService.getWallet, this.handleWalletUpdate, true);
					this.walletSubscription = this.angularBroadcastHelperService.onEvent(this, "walletChanged", (event, newWallet) => {
						this.handleWalletUpdate(newWallet);
					});
					this.userService.getWallet(); // TODO ANGULAR_2: should this be inside an interval?

					if (origin == 'siffi.com') {
						document.title = "Siffi";
					} else {
						document.title = "MinuDoc";
					}

					this.vm.initialized = true;
					var lang: any = this.vm.user.deviceLanguage || 'en_GB';
					if (lang == 'en_GB' || lang == 'et_EE' || lang == 'ru_RU' || lang == 'fi_FI') {
						this.vm.appLogoLang = lang.split("_")[0];
					} else {
						this.vm.appLogoLang = 'en';
					}
					if (origin == 'siffi.com') {
						this.vm.androidLink = 'https://play.google.com/store/apps/details?id=com.siffi&hl=' + this.vm.appLogoLang;
						this.vm.iosLink = 'https://apps.apple.com/app/siffi/id1629846508?platform=iphone';
					} else {
						this.vm.androidLink = 'https://play.google.com/store/apps/details?id=ee.minudoc&hl=' + this.vm.appLogoLang;
						this.vm.iosLink = 'https://apps.apple.com/app/minudoc/id1465732931?platform=iphone';
					}
				})
		);
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(
				this, this.config.getBroadcastConfig().Notifications.COUNT,
				(e, data) => {
					this.vm.unreadChatCount = Object.keys(data).length;
					this.updateDocumentTitle();
				})
		);
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(
				this, 'onRequestCall',
				(event, parameters) => {
					if (this.angularRoutingHelperService.getCurrentPath() !== '/call' 
						&& this.angularRoutingHelperService.getCurrentPath() !== 'call') {
						this.dialogServices.show({
							controller: ModalCallIncomingComponent,
							user: parameters.user
						});
					}
				})
		);

		this.navigationSubscription = this.router.events.subscribe(
			(event: any) => {
				if (event instanceof NavigationEnd) {
					this.updateSearchBarAndBackground();
					this.checkProfileHeaderVisibility();
				}
			}
		);
		
		this.initializeWatchers();
		
		this.vm.tabs = [{
			id: '0',
			label: 'Services.Other.Tab_All',
			name: 'ALL'
		}];
		this.vm.tabs.push({
			id: '1',
			label: 'Services.Other.Tab_Coaches',
			name: 'COACH_SUPERVISOR'
		});
		this.vm.tabs.push({
			id: '2',
			label: 'Services.Other.Tab_Therapists',
			name: 'PSYCHOLOGY'
		});
		this.vm.tabs.push({
			id: '3',
			label: 'Services.Other.Tab_Employer_Pays',
			name: 'EMPLOYER_PAYS'
		});
	}
	
	initializeWatchers() {
		var unreadChatsCount = 0;
		this.watchers.push(
			this.angularHelperService.createInterval(() => {
				var newUnreadChatsCount = this.vm.getUnreadChatsCount();
				if (unreadChatsCount !== newUnreadChatsCount) {
					unreadChatsCount = newUnreadChatsCount;
					this.angularBroadcastHelperService.rootBroadcast(
						this.config.getBroadcastConfig().Notifications.COUNT, 
						this.angularFilterHelperService.unreadChats(this.vm.chats)
					);
				}
				
				var newUncofirmedBookingsCount = this.bookingsService.getBookings('PAYED').length;
				if (this.vm.unconfirmedBookingsCount !== newUncofirmedBookingsCount) {
					this.vm.unconfirmedBookingsCount = newUncofirmedBookingsCount;
					this.updateDocumentTitle();
				}
				
				var newInstantBookingsCount = this.instantBookingService.getRequestsCount();
				if (this.vm.instantBookingsCount !== newInstantBookingsCount) {
					this.vm.instantBookingsCount = newInstantBookingsCount || 0;
					this.updateDocumentTitle();
				}
			}, 500)
		);
		
		var currentQueryParams = {};
		this.watchers.push(
			this.angularHelperService.createInterval(() => {
				var newQueryParams = this.angularRoutingHelperService.getQueryParams();
				if (!this.angularHelperService.isEqual(currentQueryParams, newQueryParams)) {
					currentQueryParams = Object.assign({}, newQueryParams);
					this.vm.search = this.urlUtil.getSearchParams();
					this.triggerSearch(true);
					this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Services.SEARCH, {
						origin: 'components/header',
						categories: this.vm.categories
					});
				}
			}, 300)
		);
	}
	
	updateSearchBarAndBackground() {
		var value = this.angularRoutingHelperService.getCurrentPath();
		if (value === "") {
			value = "/";
		} else {
			value = "/" + value;
		}
		this.vm.activePath = value;
		this.angularHelperService.createTimer(() => {
			this.updateUserData();
			this.toggleBackButton();
			
			if (!this.vm.user || this.angularHelperService.equals(this.vm.user, {})) return;
			this.checkTabsVisibility();
			this.checkProfileHeaderVisibility();
			this.vm.isSearchable = this.vm.activePath === '/' && !this.vm.user.businessUser;
			if (this.vm.isSearchable && this.vm.initialized) this.initializeSearch();
		});
	}
	
	getTags(successCallback) {
		this.restService.getServiceProviderTags({ language: this.vm.user.deviceLanguage })
			.then((tags) => {
				this.vm.availableTags = tags;
				this.processSelectedTags();
				if (successCallback) {
					successCallback();
				}
			})
			.catch((err) => {
				console.error(err);
			});
	}
	
	getTherapies() {
		this.fetchingService.get('THERAPY_TOPIC_TRANSLATIONS', { params: { language: this.vm.user.deviceLanguage || 'en_GB' } })
			.then((response) => {
				this.vm.availableTherapies = response;
			});
	}
	
	getTherapiesText() {
		if (!this.vm.search.therapies || !this.vm.search.therapies.length) {
			return this.angularFilterHelperService.translate('Services.Filter.Therapies');
		}
		var therapies: any = Array.isArray(this.vm.search.therapies)
		? Array.from(this.vm.search.therapies, (therapy) => {
			return therapy;
		}) : [this.vm.search.therapies];
		var translatedItems: Array<any> = [];
		for (var i=0; i<therapies.length; i++) {
			for (var j=0; j<this.vm.availableTherapies.length; j++) {
				if (therapies[i] === this.vm.availableTherapies[j].therapy.name) {
					translatedItems.push(this.vm.availableTherapies[j].translation);
				}
			}
		}
		return translatedItems.join(', ');
	}
	
	handleTabClick(index) {
		this.vm.selectedTab = index;
		for (var i = 0; i < this.vm.tabs.length; i++) {
			if (this.vm.tabs[i].id == this.vm.selectedTab) {
				this.vm.search.category = this.vm.tabs[i].name;
				delete this.vm.search.therapies;
			}
		}
		this.vm.triggerSearch();
	}
	
	processSelectedTags() {
		if (this.vm.availableTags) {
			var search: any = this.urlUtil.getSearchParams();
			if (search && !!search.conditions) {
				search.conditions = Array.isArray(search.conditions) ? search.conditions : [search.conditions]
				TAGS: for (var st = 0; st < search.conditions.length; st++) {
					for (var t = 0; t < this.vm.availableTags.length; t++) {
						if (search.conditions[st] === this.vm.availableTags[t].tag.name) {
							if (!this.isTagSelected(this.vm.availableTags[t])) {								
								this.vm.selectedTags.push(this.vm.availableTags[t]);
							}
							continue TAGS;
						}
					}
				}
			}
		}
	}
	
	isTagSelected(tag) {
		var result: any = this.vm.selectedTags.filter((item) => {
			return item.tag.id === tag.tag.id;
		});
		return (result || []).length > 0;
	}
	
	clearSelectedTag(tag) {
		this.vm.selectedTags = this.vm.selectedTags.filter((item) => {
			return item.tag.name !== tag.tag.name;
		});
		this.vm.triggerSearch();
	}
	
	clearAllSelectedTags($event) {
		$event.preventDefault();
		this.vm.selectedTags = [];
		this.vm.triggerSearch();
	}
	
	requestCategorySelection($event) {
		$event.preventDefault();
		this.vm.isCategorySelectionRequested = true;
	}
	
	openTagSelectionDialog($event) {
		$event.preventDefault();
		this.getTags(() => {
			var dialog = this.dialogServices.show({
				controller: ModalTagSelectionComponent,
				availableTags: this.vm.availableTags, 
				selectedTags: this.vm.selectedTags
			});
			dialog.afterClosed().subscribe(
				(data) => {
					if (dialog.close) dialog.close();
					this.vm.selectedTags = data;
					this.vm.triggerSearch();
				},
				() => {
					
				}
			);
		});
	}
	
	isProfileUpdateRequired() {
		// fix for Benu not providing as required information
		if (!this.vm.user.phone || !this.vm.user.email || this.vm.user.email.endsWith('@eesti.ee')) {
			return true;
		}
		return false;
	}
	
	handleWalletUpdate(wallet) {
		this.getSessionLimitInfo(wallet);
		if (this.angularHelperService.equals(wallet, this.vm.wallet)) return;
		this.vm.wallet = wallet || {};
		var hasIiziBusinessWallet: any = (this.vm.wallet['alternatives'] || []).find(
			(wallet) => {
				var isInsuranceType: any = (wallet['walletType'] || '').toLowerCase() === 'insurance';
				var isIiziPackageName: any = (wallet['name'] || '').toLowerCase() === 'iizi';
				return (isInsuranceType && isIiziPackageName);
			});
		if (hasIiziBusinessWallet) {
			this.vm.hasIiziBusinessWallet = true;
		}
	}
	
	updateDocumentTitle() {
		var count: any = (this.vm.instantBookingsCount || 0) + (this.vm.unconfirmedBookingsCount || 0) + (this.vm.unreadChatCount || 0);
		this.notificationService.displayTitleNotification(count);
	}
	
	checkProfileHeaderVisibility() {
		this.vm.hasSiffiHeroBanner = (this.vm.user && this.vm.user.origin == 'siffi.com');
		this.vm.isProfileHeaderVisible = this.profileServices.showProfileHeader();
		this.angularStateHelperService.setGlobalProperty('showProfile', this.vm.isProfileHeaderVisible);
	}
	
	checkTabsVisibility() {
		var isUserActive: any = this.vm.user.active;
		var isServiceActive: any = this.vm.user.service && this.vm.user.service.status && this.vm.user.service.status !== 'INCOMPLETE';
		var hiddenPaths: Array<any> = ['sp-settings', 'settings'];
		var path: any = this.angularRoutingHelperService.getCurrentPath();
		this.angularStateHelperService.setGlobalProperty('showTabs', hiddenPaths.indexOf(path) === -1 && isUserActive && isServiceActive);
	}
	
	isShowTabs() {
		var isPublicPath = this.angularHelperService.isPublicPath();
		return !isPublicPath && this.angularStateHelperService.getGlobalProperty('showTabs');
	}
	
	checkMentalHealthServiceAvailable() {
		var params: any = {
			origin: 'siffi.com'
		};
		this.serviceRestServices.getMentalHealthServiceAvailability(params,
			(serviceAvailability) => {
				this.vm.startTimeInHours = serviceAvailability['startTimeInHours'];
				this.vm.endTimeInHours = serviceAvailability['endTimeInHours'];
				this.vm.weekendStartTimeInHours = serviceAvailability['weekendStartTimeInHours'];
				this.vm.weekendEndTimeInHours = serviceAvailability['weekendEndTimeInHours'];
				this.vm.isOutOfHoursMode = this.config.isOnDemandServiceUnavailable(serviceAvailability);
			});
	}
	
	goBack(e) {
		if (e && e.preventDefault) e.preventDefault();
		history.back();
	}
	
	toggleBackButton() {
		this.vm.isBackBtnVisible = this.angularRoutingHelperService.getCurrentRouteConfigFor('backButton') || this.isChatWithBackButton();
	}
	
	isChatWithBackButton() {
		var route: any = this.angularRoutingHelperService.getCurrentRoute();
		var chatIdParam: any = this.angularRoutingHelperService.getRouteParam('id');
		return ((route && route.indexOf && route.indexOf('chats')) > 0 || (route?.originalPath && route?.originalPath?.indexOf('chats')) > 0) && chatIdParam;
	}
	
	constructMenuLinks() {
		var items: Array<any> = [];
		var dropdownItems: Array<any> = [];
		var menuType: any = 'DEFAULT';
		if (this.vm.user.origin == 'siffi.com') {
			menuType = 'DEFAULT_SIFFI';
		}
		if (this.vm.user.previsitUser == true) {
			menuType = 'DEFAULT_PREVISIT';
		}
		if (this.vm.user.businessUser && this.vm.user.businessUserType) menuType = this.vm.user.businessUserType;

		items = this.angularHelperService.copy(menu[menuType].items || []);
		items.map((item) => {
			if (item.label) item.label = this.angularFilterHelperService.translate(item.label);
			if (item.onClick) item.onClick = this.vm[item.onClick];
		});
		
		dropdownItems = this.angularHelperService.copy(menu[menuType].dropdownItems || []);
		dropdownItems.map((item) => {
			if (item.label) item.label = this.angularFilterHelperService.translate(item.label);
			if (item.onClick) item.onClick = this.vm[item.onClick];
		});
		
		this.vm.menu = this.vm.menu || {};
		this.vm.menu.items = items;
		this.vm.menu.dropdownItems = dropdownItems;
	}

	loadAssignedLearnerProgramsVisibility() {
		this.restService.getTrainingProgramsForLearner()
			.then((programs) => {
				this.vm.hasAssignedLearnerPrograms = Array.isArray(programs) && programs.length > 0;
			})
			.catch(() => {
				this.vm.hasAssignedLearnerPrograms = false;
			});
	}

	loadAssignedToolkitVisibility() {
		// Only relevant for regular (non-business) users.
		if (!this.vm?.user || this.vm.user.businessUser) {
			this.vm.hasAssignedToolkit = false;
			return;
		}

		Promise.all([
			this.toolkitService.getMyAssignmentsList({}).catch(() => []),
			this.toolkitService.getMyAssessmentAssignmentsList({}).catch(() => [])
		])
			.then(([ex, sv]) => {
				const a = Array.isArray(ex) ? ex : [];
				const b = Array.isArray(sv) ? sv : [];
				this.vm.hasAssignedToolkit = a.filter((x) => x && !x.isDeleted).length + b.filter((x) => x && !x.isDeleted).length > 0;
			})
			.catch(() => {
				this.vm.hasAssignedToolkit = false;
			});
	}

	isVisibleForUser(menuItem) {
		if (this.vm.user.partnerAccount === true && menuItem.href === '/schedule') {
			return false;
		}
		if (!this.toolkitMenuVisible && (menuItem.href === '/toolkit' || menuItem.href === '/my-exercises')) {
			return false;
		}
		if (menuItem.href === '/toolkit') {
			return this.isPsychologyServiceProvider();
		}
		if (menuItem.href === '/assigned-training-programs') {
			return !!this.vm.hasAssignedLearnerPrograms;
		}

		if (menuItem.href === '/my-exercises') {
			return !!this.vm.hasAssignedToolkit;
		}
		if (menuItem.href === '/partners') {
			return this.vm.user.parentBusinessUser
				&& this.vm.user.parentBusinessUser.service
				&& this.vm.user.parentBusinessUser.service.partnersEnabled === true;
		}
		if (menuItem.href === '/pre-visit/record-ticket-for-person' && this.vm.user.service && !this.vm.user.service.preVisitEnabled) {
			return false;
		}
		if (menuItem.href === '/invoices' && this.vm.user.service && this.vm.user.service.walletType === 'MOBILE_PACKAGE') {
			return false;
		}
		if (menuItem.href === '/corporate-insurance' && this.vm.user.origin == 'siffi.com') {
			return false;
		}
		if (menuItem.href === '/limits' && this.vm.user.origin == 'siffi.com') {
			return false;
		}
		if (this.vm.user.adminAssistant && menuItem.onClick && menuItem.onClick.name === 'editProfile') {
			return false;
		}
		if (menuItem.id == 'toggleServiceProviderRole') {
			return this.vm.user.businessUserType === 'SERVICE_PROVIDER' || this.vm.user.businessRoleDisabled;
		}
		if (menuItem.id == 'toggleAdminAssistantStatus') {
			return this.vm.user.hasAdminAssistantRights
				&& (!this.vm.user.businessUserType || this.vm.user.businessUserType === 'SERVICE_PROVIDER');
		}
		if (menuItem.href === '/limits'
			&& this.vm.user.businessUserType === 'BUSINESS_CLIENT'
			&& this.vm.user.activeInsurancePolicies
			&& this.vm.user.activeInsurancePolicies.length > 0
			&& this.vm.user.businessClientSettings
			&& !this.vm.user.businessClientSettings.allowedFields) {
			return false;
		}
		if (menuItem.href === '/dependents') {
			if (this.vm.user.businessUserType === 'BUSINESS_CLIENT'
				&& this.vm.user.service.businessDependentsSettings
				&& this.vm.user.service.businessDependentsSettings.id) {
				if (this.vm.user.service.businessDependentsSettings.dependentsSupportedWithInsurance
					&& this.vm.user.activeInsurancePolicies
					&& this.vm.user.activeInsurancePolicies.length > 0) {
					// TODO SEN-1704 - is policy package dependents settings checking also required here?
					return true;
				} else {
					return this.vm.user.service.businessDependentsSettings.dependentsSupportedWithSubscription
						|| this.vm.user.service.businessDependentsSettings.dependentsSupportedWithCompanyInvoice;
				}
			} else {
				return false;
			}
		}
		if (menuItem.href === '/therapy-fund-wallets') {
			return this.vm.user.businessUserType === 'SERVICE_OWNER' && this.vm.user.service.therapyFundSupported;
		}
		return true;
	}

	private isPsychologyServiceProvider(): boolean {
		const user = this.vm?.user || {};
		const allowedSubcategories = ['PSYCHOLOGY', 'GENERAL_MEDICAL_PRACTICE', 'PHYSIOTHERAPY'];
		return user.businessUserType === 'SERVICE_PROVIDER'
			&& !!user.service
			&& allowedSubcategories.includes(user.service.subcategory);
	}
	
	reload(event) {
		if (event && event.preventDefault) {
			event.preventDefault();
		}
//		this.angularRoutingHelperService.clearQueryParamsDirty()
//		if (this.vm.activePath === this.angularRoutingHelperService.goHomeAndReturnPath(this.session.getSession() 
//			? this.session.getSession().user : null)) {
//			this.angularRoutingHelperService.reloadRoute();
//		} else {
//			this.angularRoutingHelperService.goHomeAndKeepHistory(this.session.getSession().user);
//		}
		// TODO ANGULAR_2: if below works, remove above
		var currentSession = this.session.getSession();
		this.angularRoutingHelperService.home(currentSession && currentSession.user);
	}
	
	reloadToPrevisit(event) {
		if (event && event.preventDefault) {
			event.preventDefault();
		}
		this.angularRoutingHelperService.clearQueryParamsDirty()
		if (this.vm.user
				&& this.vm.user.businessUserType === 'SERVICE_PROVIDER'
				&& this.vm.user.service
				&& this.vm.user.service.preVisitEnabled) {
			this.angularRoutingHelperService.setPath('/pre-visit/record-ticket-for-person');
		} else {
			this.angularRoutingHelperService.setPath('/pre-visit');
		}
	}
	
	checkAutoplay() {
		var audio: any = new Audio('https://dqs3afosyxqoy.cloudfront.net/assets/common/audio/test/test.mp3');
		var promise: any = audio.play();
		if (!promise || this.vm.isAutoplayChecked) return;
		this.vm.isAutoplayChecked = true;
		
		promise.then(() => {
			
		})
		.catch((err) => {
			try {
				// this.displaySafariWarning();
			} catch (e) {
				console.log(e);
			}
		});
	}
	
	displaySafariWarning() {
		var _window: any = window;
		var isAdminUser: any = this.vm.user['businessUserType'] === "BUSINESS_CLIENT"
			|| this.vm.user['businessUserType'] === "SERVICE_OWNER";
		var isMacSafari: any = _window.safari !== undefined && !!_window.navigator.platform.match(/Mac/);
		if (!isAdminUser && isMacSafari) {
			var userAgent: any = window.navigator.userAgent;
			var agentMatcher: any = userAgent.match(/Version\/(\d+)/);
			var version: any = userAgent.indexOf('Version') !== -1
			? parseInt(agentMatcher != null && agentMatcher.length > 0 ? agentMatcher[1] : '0', 10)
			: 0;
			if (version >= 11) {
				this.dialogServices.show({
					controller: ModalBrowserInfoComponent
				});
			}
		}
	}
	
	editProfile(event, controller?, successCallback?, errorCallback?) {
		if (event && event.preventDefault) event.preventDefault();
		controller.updateUserData();
		controller.profileServices.openProfileModal(controller.vm.user, event,
			(newProfile) => {
				controller.vm.user = newProfile;
				controller.session.updateSession();
				if (typeof successCallback === "function") successCallback();
			},
			() => {
				if (typeof errorCallback === "function") errorCallback();
			}
		);
	}
	
	onEditProfileDialogClosed() {
		if (this.vm.user.workerInvitation) {
			this.businessService.showEmployerInvitationModal(
			this.vm.user,
			this.checkInsuranceAttentionRequired,
			this.checkInsuranceAttentionRequired);
		} else {
			this.checkInsuranceAttentionRequired();
		}
	}
	
	checkInsuranceAttentionRequired() {
		this.restService.getUserIncompletePolicyList({})
			.then((incompletePolicies) => {
				if (incompletePolicies.length > 0) {
					this.insuranceService.openInsuranceAttentionRequiredModal(incompletePolicies[0], 
						(incompletePolicy) => {
							var isUserSettingsRequired: any = !!(incompletePolicy
								&& incompletePolicy['policy']['purchasedPackage']['userSettingsRequired']);
							var isBankAccountRequired: any = !!(incompletePolicy
								&& incompletePolicy['policy']['purchasedPackage']['policyUserBankAccountRequired']);
							var isHealthQuestionnaireRequired: any = !!(incompletePolicy
							&& incompletePolicy['policy']['purchasedPackage']['healthQuestionnaire']
							&& incompletePolicy['policy']['purchasedPackage']['healthQuestionnaire']['id']
							);
							var healthQuestionnaireId: any = isHealthQuestionnaireRequired
								? incompletePolicy['policy']['purchasedPackage']['healthQuestionnaire']['id']
								: 0;
							
							var queryParams = {};
							queryParams['mode'] = 'complete';
							queryParams['policyUserId'] = incompletePolicy.id;
							queryParams['userSettingsRequired'] = isUserSettingsRequired ? 'yes' : 'no';
							queryParams['bankAccountRequired'] = isBankAccountRequired ? 'yes' : 'no';
							queryParams['questionnaireRequired'] = isHealthQuestionnaireRequired ? 'yes' : 'no'; 
							if (isHealthQuestionnaireRequired) {
								queryParams['questionnaireId'] = healthQuestionnaireId;
							}
							this.angularRoutingHelperService.setPath("/policy-settings", false, false, queryParams);
						});
				}
			})
			.catch((error) => {
				console.error(error);
			});
	}
	
	updateUserData() {
		var currentSession = this.session.getSession();
		this.vm.user = currentSession && currentSession.user || {};
		this.vm.isInstantBookingAllowed = this.instantBookingService.isAllowed(this.vm.user);
		this.vm.locale = this.vm.user.deviceLanguage;

		this.processSelectedTags();
	}
	
	logout(e, caller) {
		if (e.preventDefault) e.preventDefault();
		caller.session.logoutWithConfirmation(e);
	}
	
	toggleServiceProviderRole(e, caller) {
		if (e.preventDefault) e.preventDefault();
		caller.session.switchServiceProviderRole(e);
	}
	
	toggleAdminAssistantStatus(e, caller) {
		if (e.preventDefault) e.preventDefault();
		caller.session.toggleAdminAssistantStatus(e);
	}
	
	shouldBeVisible() {
		if (this.angularRoutingHelperService.getCurrentPath() === 'av-test' 
			|| this.angularRoutingHelperService.getCurrentPath() === 'pre-visit-chat/:id'
			|| this.angularRoutingHelperService.getCurrentPath() === 'survey') {
			return false;
		}
		var currentSession = this.session.getSession();
		var user: any = currentSession && currentSession.user;
		if (!user) return false;
		return ((this.angularRoutingHelperService.getCurrentPath() !== '/call' && this.angularRoutingHelperService.getCurrentPath() !== 'call') 
			&& this.session.isLoggedIn());
	}
	
	checkMentalHealthService() {
		if (!this.vm.mentalHealthCheckLoading) {
			this.vm.mentalHealthCheckLoading = true;
			
			var el1: any = document.getElementById("btn-hero-banner");
			if (el1) {
				el1.style.display = 'none';
			}
			var el2: any = document.getElementById("btn-hero-banner-loader");
			if (el2) {
				el2.style.display = 'block';
			}
			
			var params: any = {};
			this.serviceRestServices.getMentalHealthServiceStatus(params, (statusResult) => {
				this.vm.mentalHealthCheckLoading = false;
				if (statusResult && statusResult.status === 'ACTIVE') {
					this.angularRoutingHelperService.clearQueryParamsDirty()
					this.angularRoutingHelperService.setPath('/booking/mental-check', false, false, { step: 'CONSULTANT' });
				} else {
					this.angularRoutingHelperService.setPath("/booking/mental-check-unavailable");
				}
			});
		}
	}
	
	toggleLangMenu(toOpen) {
		if (typeof toOpen === 'undefined') toOpen = !this.vm.langOpen;
		this.vm.langOpen = toOpen;
		if (toOpen) this.bindLangMenuClose();
	}
	
	bindLangMenuClose() {
		this.angularHelperService.createTimer(() => {
			this.angularHelperService.element(document).on('click.cm touchstart.cm', () => {
				this.angularHelperService.element(document).off('click.cm touchstart.cm');
				this.angularHelperService.createTimer(() => {
					this.ngZone.run(() => {
						this.toggleLangMenu(false);
					});
				}, 100);
			});
		});
	}
	
	setLocale(locale) {
		if (this.vm.langDisabled) return;
		this.vm.langDisabled = true;
		
		var user: any = this.angularHelperService.copy(this.session.getSession().user);
		user.deviceLanguage = locale;
		
		this.userRestServices.update(user, () => {
			this.angularHelperService.getWindow().location.reload();
		});
	}
	
	getLocaleOption(locale) {
		return this.appLanguageService.getLanguage(locale);
	}
	
	toggleDrawer(e) {
		if (e && e.preventDefault) e.preventDefault();
		this.angularBroadcastHelperService.rootBroadcast("openMainDrawer", {});
	}
	
	initializeSearch() {
		this.getCategories();
		this.getTherapies();
		
		this.vm.search = this.urlUtil.getSearchParams();
	}
	
	getCategories() {
		this.categoryService.getFilters().then((categories) => {
			this.vm.categories = categories;
		});
	}
	
	triggerSearch(isStatic) {
		if (!this.vm.search) {
			return;
		}
		var category: any = this.vm.search.category;
		if (!(category === 'COACH_SUPERVISOR' || category === 'PSYCHOLOGY' || category === 'EMPLOYER_PAYS')) {
			this.vm.selectedTab = 0;
			this.vm.selectedTags = [];
			this.vm.search.therapies = [];
		}
		this.vm.search.conditions = this.vm.selectedTags.map(function(item) {
			return item.tag.name;
		});
		var search: any = this.angularHelperService.copy(this.vm.search || {});
		if (search.lang) search.lang = search.lang.join(',');
		if (search.typeOfAppointment) search.typeOfAppointment = search.typeOfAppointment;
		if (search.therapies) search.therapies = Array.isArray(search.therapies)
			? search.therapies.join(',')
			: search.therapies;
		if (search.coachingTopics) search.coachingTopics = Array.isArray(search.coachingTopics)
			? search.coachingTopics.join(',')
			: search.coachingTopics;
		Object.keys(search).forEach(function (key) {
			const value = search[key];
			if (value === '' || value === null || value === undefined ||
				(Array.isArray(value) && value.length === 0)) {
				delete search[key];
			}
		});
		if (!isStatic) this.angularRoutingHelperService.setQueryParams(search);
		if (category === 'COACH_SUPERVISOR' || category === 'PSYCHOLOGY') {
			this.vm.isCategorySelectionRequested = false;
		} else {
			this.vm.isCategorySelectionRequested = true;
		}
		if (category === 'PSYCHOLOGY') {
			this.vm.isCategoryPsychology = true;
		} else {
			this.vm.isCategoryPsychology = false;
		}
	}
	
	getCategoryTranslation() {
		var translation: any = '';
		var category: any = this.vm.search.category;
		if (!this.vm.categories) return '';
		this.vm.categories.forEach(function(item) {
			if (item.subcategory === 'COACHING' && category === 'COACH_SUPERVISOR') {
				translation = item.translation;
			} else if (item.furtherSubcategory === 'TOOTUKASSA_PSYCHOLOGIST' && category === 'TOOTUKASSA_PSYCHOLOGIST') {
				translation = item.translation;
			} else if (item.subcategory === 'PSYCHOLOGY' && !item.furtherSubcategory && category === 'PSYCHOLOGY') {
				translation = item.translation;
			}
		});
		return translation;
	}
	
	isTagFilterVisible() {
		var category: any = this.vm.search.category;
		return (category === 'COACH_SUPERVISOR' || category === 'PSYCHOLOGY');
	}
	
	getLanguagesText() {
		if (!this.vm.search?.lang || !this.vm.search?.lang?.length) return this.angularFilterHelperService.translate('Services.Filter.Languages');
		return Array.from(this.vm.search.lang, (lang) => {
			return this.angularFilterHelperService.translate('Services.Language.' + lang);
		}).join(', ');
	}
	
	getSessionLimitInfo(wallet) {
		if(wallet != null) {
			if (wallet.businessWallet != null) {
				var sessionLimit: any = wallet.businessWallet.sessionLimit != null ? wallet.businessWallet.sessionLimit : 0;
				var sessionsUsed: any = wallet.businessWallet.sessionsUsed != null ? wallet.businessWallet.sessionsUsed : 0;
				this.vm.user.sessionsLeft = sessionLimit - sessionsUsed;
			}
		}
	}
	
	goToPharmacy() {
		if (this.vm.prescriptionRenewals.length >= 1) {
			this.dialogServices.show({
				controller: ModalPharmacyConsentsComponent,
				booking: this.vm.prescriptionRenewals[0],
				clickOutsideToClose: false,
				escapeToClose: false,
				multiple: false,
			});
		}
	}
	
}
